module.exports = __webpack_public_path__ + "img/slim.1734f0d4.png";